import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ShippingArrivalModel } from '../models/rma.model';
import { UserService } from './user.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RmaService {

 readonly apiController = "/RmaShippingArrivals";
 BaseURI : string;
 
 form : FormGroup = ShippingArrivalModel.getFormGroup();  

 constructor(private http : HttpClient, private userservice : UserService) { 
   console.log("constructor : RmaService ");
   this.BaseURI = window.location.origin + "/api";
 }

 populateForm(item) {
  
  this.form.setValue(item);
 }

 getDetail(id) 
 {
    return this.http.get(this.BaseURI + this.apiController + "/" + id);
 }

 getList()
 {
    return this.http.get(this.BaseURI + this.apiController);
 }



 insertData(item) {
   item.createBy = this.userservice.getUserID();
   return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["arrivalId", "createTime"]));
 }

 updateData(item) {
   return this.http.put(this.BaseURI + this.apiController + "/" + item.arrivalId, item);
 }


 deleteData(id)
 {
   return this.http.delete(this.BaseURI + this.apiController + "/" + id);

 }

 
 
 initializeFormGroup(){
  ShippingArrivalModel.initializeFormGroup(this.form);
 }
 
}
